import React from 'react';

interface TabNavItem {
  id: string;
  label: string;
  icon?: React.ReactNode;
  count?: number;
  adminOnly?: boolean;
}

interface TabNavProps {
  tabs: TabNavItem[];
  active: string;
  onChange: (id: string) => void;
}

export function TabNav({ tabs, active, onChange }: TabNavProps) {
  return (
    <div style={{
      display: 'flex',
      gap: '0.375rem',
      overflowX: 'auto',
      WebkitOverflowScrolling: 'touch',
      paddingBottom: '0.5rem',
    }}>
      {tabs.map(tab => {
        const isActive = active === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.375rem',
              background: isActive ? 'var(--gradient-gemini)' : 'transparent',
              border: isActive ? '1px solid transparent' : '1px solid transparent',
              cursor: 'pointer',
              padding: '0.5rem 1rem',
              fontSize: 'var(--text-sm)',
              fontWeight: isActive ? 600 : 400,
              color: isActive ? '#FFFFFF' : 'var(--color-text-muted)',
              boxShadow: isActive ? 'var(--shadow-glow)' : 'none',
              borderRadius: 'var(--radius-interactive)',
              marginBottom: 0,
              transition: 'all var(--spring-duration) var(--spring-easing)',
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
          >
            {tab.icon}
            {tab.label}
            {tab.count !== undefined && (
              <span style={{
                fontSize: 'var(--text-xs)',
                fontWeight: 600,
                padding: '0.1rem 0.4rem',
                borderRadius: 'var(--radius-full)',
                background: isActive ? 'var(--color-primary-highlight)' : 'var(--glass-bg-card)',
                color: isActive ? 'var(--color-primary)' : 'var(--color-text-faint)',
                minWidth: '1.25rem',
                textAlign: 'center',
                lineHeight: 1.4,
              }}>
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
